// Dependencies
import React from 'react';

import SeatingplanElement from './SeatingplanElement.jsx';
// Styles


class SeatingplanElements extends React.Component {
	constructor() {
		super();
		this.stopRender = 0;
	}


	shouldComponentUpdate(nextProps, nextState) {
		// Das ist sehr wichtig für die perfomance sollte aber mal besser implemenetiert werden.
		if (nextState) {
			//
		}

		if (!this.props.elements) {
			console.info('rendering all seats');
			return true;
		}
		if (!nextProps.elements) {
			console.info('rendering all seats');
			return true;
		}
		if (this.props.elements.length !== nextProps.elements.length) {
			console.info('rendering all seats');
			return true;
		}
		return false;
	}

	render() {
		return (
			<g>
				{this.props.elements.map(el =>
					<SeatingplanElement element={el} key={el.uuid} />
				)
				}
			</g>
		);
	}
}

export default SeatingplanElements;

